import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "stoptask",
  "use": "stoptask-usage",
  "viewBox": "0 0 44.29 50.63",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44.29 50.63\" id=\"stoptask\"><title>资源 89</title><g data-name=\"图层 2\"><g data-name=\"图层 1\"><path d=\"M42.71 32.47a1.58 1.58 0 0 1-1.58-1.58V3.16h-38v44.3h20.6a1.58 1.58 0 1 1 0 3.16H3.16A3.16 3.16 0 0 1 0 47.46V3.16A3.16 3.16 0 0 1 3.16 0h38a3.16 3.16 0 0 1 3.16 3.16v27.73a1.58 1.58 0 0 1-1.61 1.58z\" /><path d=\"M41.33 35.93a8.61 8.61 0 1 0 0 12.18 8.62 8.62 0 0 0 0-12.18zm-10.28 1.9a5.92 5.92 0 0 1 7.31-.83l-8.15 8.15a5.92 5.92 0 0 1 .85-7.32zm9.21 7.32A5.91 5.91 0 0 1 32.12 47l8.15-8.15a5.91 5.91 0 0 1 0 6.31zm-31.65-12A1.52 1.52 0 0 1 7 31.8a1.52 1.52 0 0 1 1.65-1.35h10.86a1.52 1.52 0 0 1 1.65 1.35 1.52 1.52 0 0 1-1.65 1.35zm0-9.96A1.52 1.52 0 0 1 7 21.85a1.52 1.52 0 0 1 1.61-1.35H22.5a1.35 1.35 0 0 1 0 2.69h-.27zM7 10.81a1.52 1.52 0 0 1 1.61-1.34h16.82a1.52 1.52 0 0 1 1.65 1.35 1.52 1.52 0 0 1-1.65 1.35H8.61A1.52 1.52 0 0 1 7 10.81z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/stoptask.svg
// module id = 7RWK
// module chunks = 6